import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {fileFormatFamilies} from '@netx/core-search/properties/search';
import {RuleModel} from '../baseModel';
import {
	SearchTypeFileFormatFamily,
	TSearchTypeFileFormatFamily,
} from './constants';
import {fileFormatFamilyRuleDefaults} from './defaults';
import type {FileFormatFamilyRule} from './types';
import {validateFileFormatFamily} from './validate';

export class FileFormatFamilyRuleModel
	extends RuleModel<TSearchTypeFileFormatFamily>
	implements FileFormatFamilyRule
{
	readonly elementType = SearchTypeFileFormatFamily;
	elementSubType1: 4 = fileFormatFamilyRuleDefaults.elementSubType1;
	elementSubType2: 0 = fileFormatFamilyRuleDefaults.elementSubType2;
	elementValue1 = fileFormatFamilyRuleDefaults.elementValue1;
	elementValue2: '' = fileFormatFamilyRuleDefaults.elementValue2;
	elementValue3: '' = fileFormatFamilyRuleDefaults.elementValue3;

	get isValid() {
		const validation = validateFileFormatFamily(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<FileFormatFamilyRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {
				...fileFormatFamilyRuleDefaults,
				elementValue1: Object.values(fileFormatFamilies)[0],
				...params,
			});
		});

		makeObservable(this, {
			isValid: computed,
			elementValue1: observable,
			setElementValue1: action,
		});
	}

	/** stubbed */
	setElementSubType1() {}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set file format family
	 * @param elementValue1 file format family
	 */
	setElementValue1(elementValue1: string) {
		this.elementValue1 = elementValue1;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default FileFormatFamilyRuleModel;
